import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check, X, ClockClockwise } from "@phosphor-icons/react";
import { api } from "../../lib/api";

const summarize = (pc) => {
  const parts = [];
  const c = Object.keys(pc.content || {});
  const s = Object.keys(pc.settings || {});
  if (c.length) parts.push(`${c.length} content field${c.length > 1 ? "s" : ""}: ${c.join(", ")}`);
  if (s.length) parts.push(`settings: ${s.join(", ")}`);
  return parts.join(" · ") || "No changes";
};

export const ReviewPanel = ({ onChange }) => {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/pending").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const act = async (id, action) => {
    try {
      await api.post(`/admin/pending/${id}/${action}`);
      toast.success(action === "approve" ? "Change approved and published" : "Change rejected");
      load(); onChange && onChange();
    } catch (e) { toast.error(e?.response?.data?.detail || "Action failed"); }
  };

  return (
    <div className="space-y-4" data-testid="review-panel">
      {items.length === 0 && (
        <div className="text-center py-16 text-navy/50">
          <ClockClockwise size={44} className="mx-auto text-navy/30" />
          <p className="mt-3">No changes waiting for approval.</p>
        </div>
      )}
      {items.map((pc) => (
        <div key={pc.id} className="bg-white border border-navy/10 p-5" data-testid="pending-item">
          <div className="flex flex-wrap justify-between gap-2">
            <span className="font-heading text-lg text-navy">{pc.description}</span>
            <span className="text-xs uppercase tracking-wide bg-gold/20 text-navy px-2 py-1 rounded-sm h-fit">Pending</span>
          </div>
          <div className="text-sm text-navy/60 mt-1">By {pc.submitted_by_email} · {new Date(pc.created_at).toLocaleString()}</div>
          <p className="mt-3 text-sm text-navy/80"><span className="font-medium">Proposed:</span> {summarize(pc)}</p>
          <div className="mt-4 flex gap-3">
            <button onClick={() => act(pc.id, "approve")} data-testid={`approve-${pc.id}`} className="inline-flex items-center gap-2 bg-navy text-white font-semibold px-5 py-2.5 rounded-sm hover:bg-green-700 transition-colors">
              <Check size={18} /> Approve & publish
            </button>
            <button onClick={() => act(pc.id, "reject")} data-testid={`reject-${pc.id}`} className="inline-flex items-center gap-2 border border-navy/20 text-navy font-semibold px-5 py-2.5 rounded-sm hover:border-red-500 hover:text-red-500 transition-colors">
              <X size={18} /> Reject
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};
